var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddPhotoAlternate = function SvgAddPhotoAlternate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.98 15.375q-.567 0-.961-.394a1.3 1.3 0 0 1-.394-.962V3.981q0-.57.394-.962.393-.394.962-.394h5.625V3.75H3.98a.22.22 0 0 0-.166.065.22.22 0 0 0-.065.166v10.038q0 .102.065.166a.22.22 0 0 0 .166.065h10.038a.22.22 0 0 0 .166-.065.22.22 0 0 0 .065-.166V8.394h1.125v5.625q0 .57-.394.962a1.3 1.3 0 0 1-.962.394zm.809-2.856h8.422l-2.617-3.49-2.25 2.92L6.75 9.924zM12.75 6.75v-1.5h-1.5V4.125h1.5v-1.5h1.125v1.5h1.5V5.25h-1.5v1.5z"
  })));
};
export default SvgAddPhotoAlternate;